import React, { useEffect, useState } from 'react'
import { Box, useMediaQuery } from '@material-ui/core'
import { Text, RoundedBox, IconButton, InfoDialog } from '../'

import { Info } from 'react-feather'

import useFirstStep from 'hooks/useFirstStep'

import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from './styles'

import theme from 'theme'

const LGPDPage = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const { activeStep, activeSubStep, setBackgroundKind, registerTrack } =
    useFirstStep()
  const handleOpen = () => setOpen(true)

  useEffect(
    () => {
      setBackgroundKind('topRight')
      registerTrack(
        helpers.userSteps.defineMixpanelId(
          activeStep,
          activeSubStep,
          'play-video',
        ),
      )
    },
    //eslint-disable-next-line
    [],
  )

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  })

  return (
    <>
      <Text color="primary" fontSize="5vh" variant="h1" gutterBottom={isMobile}>
        O que é a LGPD?
      </Text>
      <Text color="secondary" fontSize="3vh" variant="h4" gutterBottom>
        Lei Geral de Proteção de Dados
      </Text>
      <RoundedBox>
        <Box width="100%" display="flex" alignItems="flex-start">
          <iframe
            title="WelcomeVideo"
            src="https://player.vimeo.com/video/660687255?h=a59718af83&badge=0&amp;autoplay=true&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            className={classes.iFrame}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
          />
          <Box className={classes.boxIcon}>
            <IconButton
              icon={<Info />}
              onClick={handleOpen}
              mixpanelId={helpers.userSteps.defineMixpanelId(
                activeStep,
                activeSubStep,
                'informação',
              )}
            />
          </Box>
        </Box>
      </RoundedBox>
      <InfoDialog
        open={open}
        setOpen={setOpen}
        {...constants.userSteps.DIALOG_INFOS.LGPD}
      />
    </>
  )
}

export default LGPDPage
